module.exports = __webpack_public_path__ + "static/media/service.08e81878.png";